import { render, staticRenderFns } from "./TaskStatus.vue?vue&type=template&id=8463d39a&"
import script from "./TaskStatus.vue?vue&type=script&lang=ts&"
export * from "./TaskStatus.vue?vue&type=script&lang=ts&"
import style0 from "./TaskStatus.vue?vue&type=style&index=0&id=8463d39a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports